import {
  COMPANY_SIZE_BUCKET,
  MONITORING_LIST_PANEL_STEPS,
  REVENUE_BUCKET
} from "./enums";
import { BucketRange } from "./interfaces";

export const MAX_VISIBLE_CUSTOMERS = 5;

export const CUSTOMER_OVERVIEW_TABLE_MENUS = [
  {
    link: "introduction",
    iconName: "sticky_note_2",
    label: "introduction"
  },
  {
    link: "decision-making",
    iconName: "lightbulb",
    label: "decisionMaking"
  },
  {
    link: "sentiment-analysis",
    iconName: "bar_chart",
    label: "sentimentAnalysis"
  },
  {
    link: "value-proposition",
    iconName: "grid_view",
    label: "valueProposition"
  },
  {
    link: "budget-outlook",
    iconName: "paid",
    label: "budgetOutlook"
  },
  {
    link: "competition",
    iconName: "target",
    label: "competition"
  },
  {
    link: "analyst-recommendation",
    iconName: "manage_search",
    label: "analystRecommendation"
  }
];

export const CUSTOMER_OVERVIEW_SHARE_DATA_TABLE_MENUS = [
  {
    link: "share",
    iconName: "share",
    label: "share"
  },
  {
    link: "download",
    iconName: "file_download",
    label: "downloadPdf"
  }
];

export const TAG_COLOR_MAP: Record<string, string> = {
  Detractor: "error",
  detractor: "error",
  Neutral: "warning",
  neutral: "warning",
  Promoter: "success",
  promoter: "success",
  No: "error",
  NotSure: "warning",
  Yes: "success",
  Offboarding: "error"
};

export const COMPANY_PANEL_STEPS = [
  MONITORING_LIST_PANEL_STEPS.SELECT_COMPANY,
  MONITORING_LIST_PANEL_STEPS.CREATE_COMPANY
];

export const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

export const SPEND_CONSTANTS = {
  SMALL_THRESHOLD: 20000,
  LARGE_THRESHOLD: 100000
};

const MILLION = 1_000_000;
const BILLION = 1_000_000_000;

export const COMPANY_SIZE_RANGE: Record<COMPANY_SIZE_BUCKET, BucketRange> = {
  [COMPANY_SIZE_BUCKET.Micro]: { min: 1, max: 50 },
  [COMPANY_SIZE_BUCKET.Small]: { min: 51, max: 200 },
  [COMPANY_SIZE_BUCKET.Medium]: { min: 201, max: 1000 },
  [COMPANY_SIZE_BUCKET.Large]: { min: 1001, max: 5000 },
  [COMPANY_SIZE_BUCKET.Enterprise]: { min: 5001, max: Number.POSITIVE_INFINITY }
};

export const REVENUE_RANGE: Record<REVENUE_BUCKET, BucketRange> = {
  [REVENUE_BUCKET.Micro]: { min: 0, max: 10 * MILLION - 1 },
  [REVENUE_BUCKET.Small]: { min: 10 * MILLION, max: 50 * MILLION - 1 },
  [REVENUE_BUCKET.Medium]: { min: 50 * MILLION, max: 250 * MILLION - 1 },
  [REVENUE_BUCKET.Large]: { min: 250 * MILLION, max: BILLION - 1 },
  [REVENUE_BUCKET.Enterprise]: { min: BILLION, max: Number.POSITIVE_INFINITY }
};

export const COMPANY_SIZE_OPTIONS: {
  value: COMPANY_SIZE_BUCKET;
  labelKey: string;
}[] = [
  { value: COMPANY_SIZE_BUCKET.Micro, labelKey: "companySize.micro" },
  { value: COMPANY_SIZE_BUCKET.Small, labelKey: "companySize.small" },
  { value: COMPANY_SIZE_BUCKET.Medium, labelKey: "companySize.medium" },
  { value: COMPANY_SIZE_BUCKET.Large, labelKey: "companySize.large" },
  { value: COMPANY_SIZE_BUCKET.Enterprise, labelKey: "companySize.enterprise" }
];

export const REVENUE_OPTIONS: { value: REVENUE_BUCKET; labelKey: string }[] = [
  { value: REVENUE_BUCKET.Micro, labelKey: "revenue.micro" },
  { value: REVENUE_BUCKET.Small, labelKey: "revenue.small" },
  { value: REVENUE_BUCKET.Medium, labelKey: "revenue.medium" },
  { value: REVENUE_BUCKET.Large, labelKey: "revenue.large" },
  { value: REVENUE_BUCKET.Enterprise, labelKey: "revenue.enterprise" }
];
